import {inject, Injectable} from '@angular/core';
import {InvoiceDetailsDTO} from '@dto/invoices/invoice-details-dto.model';
import {InvoiceDetailsViewModel} from './invoice-detail-view.model';
import {DateConverterService} from '@shared/services/date-converter.service';
import {FormattedNumber} from '@components/ui/table-template/classes/formatted-number';
import {Utils} from '@shared/utilities/utils';
import {IconViewModel} from '@components/ui/table-template/models/icon-view-model';
import {IconSize} from '@components/ui/table-template/enums/icon-size.enum';
import {DateFormatterService} from '@shared/services/date-formatter.service';
import {IconColour} from '@components/ui/table-template/enums/icon-colour.enum';

@Injectable({
  providedIn: 'root'
})
export class InvoiceDetailsConverterService {
  private readonly dateConverterService = inject(DateConverterService);
  private readonly dateFormatterService = inject(DateFormatterService);

  convert(invoiceDetailsList: InvoiceDetailsDTO[]): InvoiceDetailsViewModel[] {
    return invoiceDetailsList.map(c => this.convertSingle(c));
  }

  private convertSingle(invoiceDetails: InvoiceDetailsDTO): InvoiceDetailsViewModel {

    const iconImageUrl = Utils.getInvoiceStatusIconSource(invoiceDetails.Status);

    let iconIndex;
    switch (invoiceDetails.Status) {
      case 'Outstanding':
        iconIndex = 0;
        break;
      case 'Paid':
        iconIndex = 1;
        break;
      default:
        iconIndex = 2;
    }

    const invoiceDate = this.dateConverterService.toDate(invoiceDetails.InvoiceDate);

    const amountRemaining = new FormattedNumber(invoiceDetails.AmountRemaining);

    const detailsLabel = 'Invoice ' + invoiceDetails.InvoiceNumber + ' - ' + amountRemaining.displayValue + ' ' + invoiceDetails.CurrencyCode + ' remaining';

    return {
      Amount: new FormattedNumber(invoiceDetails.Amount),
      CurrencyCode: invoiceDetails.CurrencyCode,
      InvoiceDate: invoiceDate,
      InvoiceDateString: this.dateFormatterService.formatDate(invoiceDate),
      InvoiceNumber: invoiceDetails.InvoiceNumber,
      AmountRemaining: amountRemaining,
      StatusIcon: new IconViewModel(iconImageUrl, invoiceDetails.Status, iconIndex, IconSize.Small, IconColour.Default),
      DetailsLabel: detailsLabel,
      BillingNumber: invoiceDetails.BillingNumber
    };
  }
}
